import {z} from 'zod';

import {PurchasePriceRuleRequestBodySchema} from '@dms/api/sales';

/**
 * Values a new rule starts from. Name and scope are never copied from the source rule.
 */
export const PurchasePriceRuleTemplateSchema = PurchasePriceRuleRequestBodySchema.pick({
  priceBands: true,
  warrantyCost: true,
  modifiers: true,
});

export type PurchasePriceRuleTemplate = z.infer<typeof PurchasePriceRuleTemplateSchema>;
